module.exports = __webpack_public_path__ + "img/satelliteThumb.5fbe832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/satelliteThumb.png
// module id = RaIc
// module chunks = 8